// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#loading-modal[data-v-efe9d588] {\n  background-color: #fff;\n  width: 393px;\n  border-radius: 5px;\n  border: 1px solid #f1f1f1;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n}\n#loading-modal .title-loading[data-v-efe9d588] {\n  margin-top: 20px;\n}\n#loading-modal .icon[data-v-efe9d588] {\n  width: 4.5rem;\n  height: 4.5rem;\n}", ""]);
// Exports
module.exports = exports;
